import styled from "styled-components";
import { responsive } from "Styles/Constants";
import { COLORS } from "Styles/Constants";


//IMAGES
import { ReactComponent as InstaIcon } from "../../Assets/Images/Header/Instagram.svg";
import HeroTopVector from "../../Assets/Images/LandingPage/hero_top_vector.svg";



export const AboutUsContainer = styled.div`
   font-family: 'Outfit', sans-serif;
    .img_text_odd_even .img_text_wrapper_main:last-child .mygrid-row {
        border-bottom: 0 !important;
    }
  }

`;

